import React from "react";
import { Modal } from "antd";
import Button from "../components/shared/button";

const CaseDetailModal = ({ iscaseDetailOpen, setiscaseDetailOpen }) => {
  const handleOk = () => {
    setiscaseDetailOpen(false);
  };

  const handleCancel = () => {
    setiscaseDetailOpen(false);
  };
  return (
    <>
      <Modal
        open={iscaseDetailOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content min-h-[70vh] flex flex-col  py-[20px] px-[26px] ">
          <h5 className="text-blue font-manrope  font-medium max-w-[327px]">
            Case details
          </h5>
          <div className="flex flex-col gap-[15px] mt-[40px]">
            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">Case ID:</p>
              <p className="text-darkGrey font-semibold medium">C001</p>
            </div>
            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">Title:</p>
              <p className="text-darkGrey font-semibold medium">case1</p>
            </div>
            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">Deadline:</p>
              <p className="text-darkGrey font-semibold medium">10/15/2024</p>
            </div>
            <div className="flex items-center justify-between gap-[15px]">
              <p className="text-darkGrey font-semibold medium">Upload by:</p>
              <p className="text-darkGrey font-semibold medium">Mike Johnson</p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-[6px] mt-[60px] ">
            <img
              src="../../assets/images/dashboard/fileImg.png"
              alt=""
              className="w-[183px] h-[213px]m-auto"
            />
            <p className="small text-lightblack font-semibold">File case.PDF</p>
          </div>
          <Button
            text="Delete"
            className="button btn-blue !rounded-[39px] large mt-[95px] m-auto"
            height={45}
            width={142}
          />
        </div>
      </Modal>
    </>
  );
};

export default CaseDetailModal;
